export type SliderTarget =
  | 'liveprogram'
  | 'archiveprogram'
  | 'editprofile'
  | 'favorite'
  | 'packagelist'
  | 'packageprofile'
  | 'externallink'

export type SliderLink = {
  method: string
  rel: string
  href: string
}

export type SliderProps = {
  id: number
  order: number
  path: string
  programId: number
  target: SliderTarget
  link: SliderLink
}

export const SliderInitialState: SliderProps[] = []

